export default "__VITE_ASSET__d9121aa2__"